// removed by extract-text-webpack-plugin
module.exports = {"content":"Brand_content_2qmBl","card":"Brand_card_XGc3r","bigCard":"Brand_bigCard_20SR9"};